import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { Agent } from 'core/models/agent';
import { HttpDataService } from './http-data.service';

@Injectable()
export class AgentsService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/admins');
  }

  getFetchUrl() {
    return this.baseUrl;
  }

  getAgent(id: string): Observable<Agent> {
    return super.getItem(id);
  }

  transferAccounts(targetAgentId: string, sourceAgentId: string) {
    const url = `${this.baseUrl}/${targetAgentId}/accounts`;
    return super.putRequest(url, { sourceAgentId: sourceAgentId }, this.getRequestOptions());
  }

  changeRole(user: Agent, data: any) {
    const url = `${this.baseUrl}/${user.id}/role`;
    return super.putRequest(url, data, this.getRequestOptions());
  }

  changeClient(adminId: string, clientId: string) {
    const url = `${this.baseUrl}/${adminId}/client`;
    return super.putRequest(url, { clientId }, this.getRequestOptions());
  }
}
